import { Component } from '@angular/core';
import { CacheItem, TransferHttpService } from '../../../services/transfer-http/transfer-http.service';
import { PermissionsService } from '../../../services/permissions/permissions.service';
import { expand, take } from 'rxjs/operators';
import { LogReqHeader } from 'src/models';
import { CPPoHdr } from '../../logistics/reqs/requisitionCommon';
import { BehaviorSubject, combineLatest, EMPTY, interval, Subject, timer } from 'rxjs';
import { AuthService } from 'src/app/services/auth/auth.service';


@Component({
  selector: 'scheduledMaintenanceGenerator',
  templateUrl: './scheduledMaintenanceGenerator.component.html'
})
export class ScheduledMaintenanceGeneratorComponent {

  constructor(private transferHttp: TransferHttpService,
    public authService: AuthService,
    public permissions: PermissionsService) { }

  //***************************
  // Variables
  //***************************
  user = this.transferHttp.getCache('user');
  isAimsAdmin:boolean = this.authService.isAimsAdmin;



  //Spinner
  spinnerText: string = "Loading...";
  showSpinner: boolean = false;

  //***************************
  // Functions
  //***************************

  poTestRetVal:string[] = [];
  numberOfLoops: number = 0;
  runTest: BehaviorSubject<boolean> = new BehaviorSubject(false);
  stopped: BehaviorSubject<boolean> = new BehaviorSubject(true);
  stopPOTest(){
    this.runTest.next(false);
  }
  runPOTest() {
    this.numberOfLoops = 0;
    if (this.transferHttp.getCache(CacheItem.isDev)) {
      let numberStr = prompt("How many reqs to grab?", "50");
      if (numberStr !== null) {
        this.runTest.next(true);

        let n = +numberStr;
        this.transferHttp.getSingle(`Logistics/GetReqsForTest?howMany=${n}`).subscribe((reqs: Array<LogReqHeader>) => {
          let posToCreate: Array<CPPoHdr> = [];

          reqs.forEach(req => {
            const uniqueVendors = req.logReqLineItems
              .map(li => { return { vendId: li.acceptedVendorId, addrDc: li.acceptedVendorAddrDc } })
              .filter((v, i, arr) => arr.findIndex(ov => ov.vendId == v.vendId && ov.addrDc == v.addrDc) === i);


            for (let v of uniqueVendors) {
              try {
                let lines = req.logReqLineItems.filter(l => l.acctId !== null && l.projId !== null).map(l => l.lineItemId);
                posToCreate.push(new CPPoHdr(this.user.buyerId || "TBURR", v.vendId, v.addrDc, req, lines));
              }
              catch (e) {
                alert(e);
              }
            }
          });

          let query = this.transferHttp.post(`Logistics/CreatePO`, posToCreate);
          query.pipe(
              expand(ret => (this.runTest.value) ? query : EMPTY)
            ).subscribe(
              (ret: Array<string>) => {
                this.numberOfLoops++;
                ret.forEach(e => {
                  this.poTestRetVal.unshift(`[${this.poTestRetVal.length + 1}] `+ e);
                });
              },
              error => {
                alert(`PO Creation Error! \n ${error}`);
              }
            );

        });
      }
    }
  }

  runScheduledMaintenanceGenerator() {
    this.spinnerText = "Generating Scheduled Maintenance Templates...";
    this.showSpinner = true;
    this.transferHttp.get('ScheduledMaintenance/CreateScheduledMaintenances')
      .pipe(
        take(1)
      )
      .subscribe(ret => {
        alert("Scheduled Maintenance Generation Complete!");
        this.showSpinner = false;
      });
  }

  addClassHist() {
    this.spinnerText = "Generating Classification History...";
    this.showSpinner = true;
    this.transferHttp.get('ScheduledMaintenance/AddClassificationHistory')
      .pipe(
        take(1)
      )
      .subscribe(ret => {
        alert("CH Generation Complete!");
        this.showSpinner = false;
      });
  }

  addUsers() {
    if (confirm("NEVER EVER DO THIS UNLESS YOU ARE REALLY, REALLY F-ING SURE YOU KNOW WHAT YOU'RE DOING!  ARE YOU THAT SURE?")) {
      this.spinnerText = "Generating All Users...";
      this.showSpinner = true;
      this.transferHttp.get('Auth/GenerateAllTempPasswords?tempPass=!QAZ1qaz&createUsers=true')
        .pipe(
          take(1)
        )
        .subscribe(ret => {
          alert("User Generation Complete!");
          this.showSpinner = false;
        });
    }

  }

  create332s() {
    this.spinnerText = "Generating 332s...";
    this.showSpinner = true;
    this.transferHttp.get('Facilities/Create332WorkOrders')
      .pipe(
        take(1)
      )
      .subscribe(ret => {
        alert(`332 Generation Complete! Created ${ret}`);
        this.showSpinner = false;
      });
  }


  migrateLineItemImages() {
    this.spinnerText = "Migrating Images...";
    this.showSpinner = true;
    this.transferHttp.get('Logistics/MigrateLineItemImagesToBlob')
      .subscribe(ret => {
        alert(`Migration Complete! Migrated count: ${ret}`);
        this.showSpinner = false;
      });
  }

  //***************************
  // Init
  //***************************

  ngOnInit(): void {
  }

}
